// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__35-e-","modalFooterButton":"ModalNotes_modalFooterButton__2UdL7"};